import React from 'react'
import { Tooltip } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import BoatIcon from '@material-ui/icons/DirectionsBoat'

function LinkBuque (props) {
  const { dataBuque } = props
  const baseUrl = 'https://www.marinetraffic.com/en/ais/details/ships/'

  return (
    <>
      {dataBuque.imo
        ? <Tooltip title={'MarineTraffic'}>
          <a href={`${baseUrl}imo:${dataBuque.imo}`} target='blank' rel='' style={{ color: 'inherit' }}>
            <BoatIcon style={{ outline: 'none', color: COLORES.grey.dark }} />
          </a>
        </Tooltip>
        : (dataBuque.mmsi
          ? <Tooltip title={'MarineTraffic'}>
            <a href={`${baseUrl}mmsi:${dataBuque.mmsi}`} target='blank' rel='' style={{ color: 'inherit' }}>
              <BoatIcon style={{ outline: 'none', color: COLORES.grey.dark }} />
            </a>
          </Tooltip>
          : null)
      }
    </>
  )
}

export default LinkBuque
